import React from 'react';
import { SEO } from '../components/SEO';
import { LanguageSwitcher } from '../components/LanguageSwitcher';
import { breadcrumbSchema } from '../utils/structuredData';
import { ArrowLeftIcon } from 'lucide-react';
export function DatenschutzPage() {
  const breadcrumbs = [{
    name: 'Home',
    url: 'https://close-crm-agentur.de'
  }, {
    name: 'Datenschutz',
    url: 'https://close-crm-agentur.de/datenschutz'
  }];
  const structuredData = [breadcrumbSchema(breadcrumbs)];
  return <>
      <SEO title="Datenschutzerklärung" description="Datenschutzerklärung der Close CRM Agentur - Informationen zum Umgang mit personenbezogenen Daten." canonical="https://close-crm-agentur.de/datenschutz" noindex={true} structuredData={structuredData} data-id="element-395" data-mp="8y7xmiq8oj8h" />
      <div className="min-h-screen bg-[#0a0a0a]" data-id="element-396" data-mp="1ycmiut21tnz8">
        {/* Header */}
        <header className="fixed top-0 left-0 right-0 z-50 bg-[#0a0a0a]/80 backdrop-blur-lg border-b border-white/5" data-id="element-397" data-mp="1tecim41gvx6r">
          <nav className="max-w-7xl mx-auto px-3 sm:px-6 lg:px-8" data-id="element-398" data-mp="3i0uhkdqk2vgd">
            <div className="flex items-center justify-between h-14 sm:h-16 lg:h-20 gap-2 sm:gap-4" data-id="element-399" data-mp="3m38tsezpywyo">
              <a href="/" className="flex items-center gap-1.5 sm:gap-2 flex-shrink-0 sm:flex-1" aria-label="Close CRM Agentur Homepage" data-id="element-400" data-mp="384989g7i6y6q">
                <div className="w-7 h-7 sm:w-8 sm:h-8 rounded-lg bg-[#0ea5e9] flex items-center justify-center flex-shrink-0" data-id="element-401" data-mp="4mhatmallm15">
                  <span className="text-white font-bold text-xs sm:text-sm" data-id="element-402" data-mp="9ksk9vwzduiu">
                    C
                  </span>
                </div>
                <span className="text-white font-bold text-sm sm:text-base lg:text-lg whitespace-nowrap" data-id="element-403" data-mp="3r0r5gd54fqad">
                  Close CRM Agentur
                </span>
              </a>

              {/* Language Switcher - Always visible */}
              <LanguageSwitcher className="absolute right-3 sm:relative sm:right-0" data-id="element-404" data-mp="scv7xr81ib2l" />

              <a href="/" className="hidden sm:flex items-center justify-center gap-2 text-gray-400 hover:text-white transition-colors text-sm flex-shrink-0" data-id="element-405" data-mp="1293nrr7vo6e6">
                <ArrowLeftIcon className="w-4 h-4" data-id="element-406" data-mp="s9mjne89y0kb" />
                Zurück zur Startseite
              </a>
            </div>
          </nav>
        </header>

        {/* Main Content */}
        <main className="pt-24 pb-16" data-id="element-407" data-mp="ja7wannem641">
          <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-408" data-mp="jbalmr52w0hu">
            <div className="prose prose-invert prose-lg max-w-none" data-id="element-409" data-mp="eiptdu1tlvgf">
              <h1 className="text-4xl font-bold text-white mb-8" data-id="element-410" data-mp="9jwfi0img2fq">
                Datenschutzerklärung
              </h1>

              <div className="space-y-8 text-gray-300" data-id="element-411" data-mp="4lbo8qlckt3f">
                <section data-id="element-412" data-mp="4iqms2oyof67">
                  <h2 className="text-2xl font-bold text-white mb-4" data-id="element-413" data-mp="iymed9q1fbx">
                    1. Datenschutz auf einen Blick
                  </h2>
                  <h3 className="text-xl font-semibold text-white mb-3" data-id="element-414" data-mp="3rqudpmu0jcvb">
                    Allgemeine Hinweise
                  </h3>
                  <p className="leading-relaxed mb-4" data-id="element-415" data-mp="279tfriu9v0iu">
                    Die folgenden Hinweise geben einen einfachen Überblick
                    darüber, was mit Ihren personenbezogenen Daten passiert,
                    wenn Sie diese Website besuchen. Personenbezogene Daten sind
                    alle Daten, mit denen Sie persönlich identifiziert werden
                    können. Ausführliche Informationen zum Thema Datenschutz
                    entnehmen Sie unserer unter diesem Text aufgeführten
                    Datenschutzerklärung.
                  </p>

                  <h3 className="text-xl font-semibold text-white mb-3" data-id="element-416" data-mp="1xgcoalhlxxic">
                    Datenerfassung auf dieser Website
                  </h3>
                  <h4 className="text-lg font-medium text-white mb-2" data-id="element-417" data-mp="14tjgjj5svxyu">
                    Wer ist verantwortlich für die Datenerfassung auf dieser
                    Website?
                  </h4>
                  <p className="leading-relaxed mb-4" data-id="element-418" data-mp="3ce8fy9qolqyu">
                    Die Datenverarbeitung auf dieser Website erfolgt durch den
                    Websitebetreiber. Dessen Kontaktdaten können Sie dem
                    Abschnitt „Hinweis zur Verantwortlichen Stelle" in dieser
                    Datenschutzerklärung entnehmen.
                  </p>

                  <h4 className="text-lg font-medium text-white mb-2" data-id="element-419" data-mp="3geio9t1y4tgv">
                    Wie erfassen wir Ihre Daten?
                  </h4>
                  <p className="leading-relaxed mb-4" data-id="element-420" data-mp="3q6y4olxlh9zn">
                    Ihre Daten werden zum einen dadurch erhoben, dass Sie uns
                    diese mitteilen. Hierbei kann es sich z. B. um Daten
                    handeln, die Sie in ein Kontaktformular eingeben.
                  </p>
                  <p className="leading-relaxed mb-4" data-id="element-421" data-mp="29r51m5nchi95">
                    Andere Daten werden automatisch oder nach Ihrer Einwilligung
                    beim Besuch der Website durch unsere IT-Systeme erfasst. Das
                    sind vor allem technische Daten (z. B. Internetbrowser,
                    Betriebssystem oder Uhrzeit des Seitenaufrufs). Die
                    Erfassung dieser Daten erfolgt automatisch, sobald Sie diese
                    Website betreten.
                  </p>

                  <h4 className="text-lg font-medium text-white mb-2" data-id="element-422" data-mp="1qumnnkn9qwy8">
                    Wofür nutzen wir Ihre Daten?
                  </h4>
                  <p className="leading-relaxed mb-4" data-id="element-423" data-mp="1c0i7475xrn65">
                    Ein Teil der Daten wird erhoben, um eine fehlerfreie
                    Bereitstellung der Website zu gewährleisten. Andere Daten
                    können zur Analyse Ihres Nutzerverhaltens verwendet werden.
                  </p>

                  <h4 className="text-lg font-medium text-white mb-2" data-id="element-424" data-mp="17yn48y8cx1q9">
                    Welche Rechte haben Sie bezüglich Ihrer Daten?
                  </h4>
                  <p className="leading-relaxed mb-4" data-id="element-425" data-mp="329ify9eu8wx9">
                    Sie haben jederzeit das Recht, unentgeltlich Auskunft über
                    Herkunft, Empfänger und Zweck Ihrer gespeicherten
                    personenbezogenen Daten zu erhalten. Sie haben außerdem ein
                    Recht, die Berichtigung oder Löschung dieser Daten zu
                    verlangen. Wenn Sie eine Einwilligung zur Datenverarbeitung
                    erteilt haben, können Sie diese Einwilligung jederzeit für
                    die Zukunft widerrufen. Außerdem haben Sie das Recht, unter
                    bestimmten Umständen die Einschränkung der Verarbeitung
                    Ihrer personenbezogenen Daten zu verlangen. Des Weiteren
                    steht Ihnen ein Beschwerderecht bei der zuständigen
                    Aufsichtsbehörde zu.
                  </p>
                  <p className="leading-relaxed" data-id="element-426" data-mp="66asrkmqz2ro">
                    Hierzu sowie zu weiteren Fragen zum Thema Datenschutz können
                    Sie sich jederzeit an uns wenden.
                  </p>

                  <h3 className="text-xl font-semibold text-white mb-3 mt-6" data-id="element-427" data-mp="8qz1jdc3afrr">
                    Analyse-Tools und Tools von Drittanbietern
                  </h3>
                  <p className="leading-relaxed" data-id="element-428" data-mp="io4rgi8yw0qe">
                    Beim Besuch dieser Website kann Ihr Surf-Verhalten
                    statistisch ausgewertet werden. Das geschieht vor allem mit
                    sogenannten Analyseprogrammen. Detaillierte Informationen zu
                    diesen Analyseprogrammen finden Sie in der folgenden
                    Datenschutzerklärung.
                  </p>
                </section>

                <section data-id="element-429" data-mp="11euxgftu43nh">
                  <h2 className="text-2xl font-bold text-white mb-4" data-id="element-430" data-mp="11gp5wunx63ao">
                    2. Hosting
                  </h2>
                  <h3 className="text-xl font-semibold text-white mb-3" data-id="element-431" data-mp="1bcsk4yw1psdz">
                    Webflow
                  </h3>
                  <p className="leading-relaxed mb-4" data-id="element-432" data-mp="1ff5nxhr8fg84">
                    Wir hosten unsere Website bei Webflow. Anbieter ist die
                    Webflow, Inc., 398 11th Street, 2nd Floor, San Francisco, CA
                    94103, USA (nachfolgend Webflow). Wenn Sie unsere Website
                    besuchen, erfasst Webflow verschiedene Logfiles inklusive
                    Ihrer IP-Adressen.
                  </p>
                  <p className="leading-relaxed mb-4" data-id="element-433" data-mp="25oyo0bg4pn5u">
                    Webflow ist ein Tool zum Erstellen und zum Hosten von
                    Websites. Webflow speichert Cookies oder sonstige
                    Wiedererkennungstechnologien, die für die Darstellung der
                    Seite, zur Bereitstellung bestimmter Webseitenfunktionen und
                    zur Gewährleistung der Sicherheit erforderlich sind
                    (notwendige Cookies).
                  </p>
                  <p className="leading-relaxed mb-4" data-id="element-434" data-mp="z6ilxsfer69z">
                    Details entnehmen Sie der Datenschutzerklärung von Webflow:{' '}
                    <a href="https://webflow.com/legal/eu-privacy-policy" target="_blank" rel="noopener noreferrer" className="text-[#0ea5e9] hover:underline" data-id="element-435" data-mp="35wc2op3anwx2">
                      https://webflow.com/legal/eu-privacy-policy
                    </a>
                    .
                  </p>
                  <p className="leading-relaxed mb-4" data-id="element-436" data-mp="3on3ahm7mvf9c">
                    Die Verwendung von Webflow erfolgt auf Grundlage von Art. 6
                    Abs. 1 lit. f DSGVO. Wir haben ein berechtigtes Interesse an
                    einer möglichst zuverlässigen Darstellung unserer Website.
                    Sofern eine entsprechende Einwilligung abgefragt wurde,
                    erfolgt die Verarbeitung ausschließlich auf Grundlage von
                    Art. 6 Abs. 1 lit. a DSGVO und § 25 Abs. 1 TTDSG, soweit die
                    Einwilligung die Speicherung von Cookies oder den Zugriff
                    auf Informationen im Endgerät des Nutzers (z. B.
                    Device-Fingerprinting) im Sinne des TTDSG umfasst. Die
                    Einwilligung ist jederzeit widerrufbar.
                  </p>
                  <p className="leading-relaxed" data-id="element-437" data-mp="5vbgnodlhky2">
                    Die Datenübertragung in die USA wird auf die
                    Standardvertragsklauseln der EU-Kommission gestützt. Details
                    finden Sie hier:{' '}
                    <a href="https://webflow.com/legal/eu-privacy-policy" target="_blank" rel="noopener noreferrer" className="text-[#0ea5e9] hover:underline" data-id="element-438" data-mp="3s5p59pagpzhw">
                      https://webflow.com/legal/eu-privacy-policy
                    </a>
                    .
                  </p>
                </section>

                <section data-id="element-439" data-mp="1macm6oaot4vn">
                  <h2 className="text-2xl font-bold text-white mb-4" data-id="element-440" data-mp="1m9l1w9mjitko">
                    3. Allgemeine Hinweise und Pflichtinformationen
                  </h2>
                  <h3 className="text-xl font-semibold text-white mb-3" data-id="element-441" data-mp="1rfgib5sldv13">
                    Datenschutz
                  </h3>
                  <p className="leading-relaxed mb-4" data-id="element-442" data-mp="2574pqvrwbvbq">
                    Die Betreiber dieser Seiten nehmen den Schutz Ihrer
                    persönlichen Daten sehr ernst. Wir behandeln Ihre
                    personenbezogenen Daten vertraulich und entsprechend den
                    gesetzlichen Datenschutzvorschriften sowie dieser
                    Datenschutzerklärung.
                  </p>
                  <p className="leading-relaxed mb-4" data-id="element-443" data-mp="2o4pg67ab71yg">
                    Wenn Sie diese Website benutzen, werden verschiedene
                    personenbezogene Daten erhoben. Personenbezogene Daten sind
                    Daten, mit denen Sie persönlich identifiziert werden können.
                    Die vorliegende Datenschutzerklärung erläutert, welche Daten
                    wir erheben und wofür wir sie nutzen. Sie erläutert auch,
                    wie und zu welchem Zweck das geschieht.
                  </p>
                  <p className="leading-relaxed" data-id="element-444" data-mp="2tu7idfa4qpeg">
                    Wir weisen darauf hin, dass die Datenübertragung im Internet
                    (z. B. bei der Kommunikation per E-Mail) Sicherheitslücken
                    aufweisen kann. Ein lückenloser Schutz der Daten vor dem
                    Zugriff durch Dritte ist nicht möglich.
                  </p>

                  <h3 className="text-xl font-semibold text-white mb-3 mt-6" data-id="element-445" data-mp="3crrynxytwfng">
                    Hinweis zur verantwortlichen Stelle
                  </h3>
                  <p className="leading-relaxed mb-4" data-id="element-446" data-mp="3mimvtxdm4zno">
                    Die verantwortliche Stelle für die Datenverarbeitung auf
                    dieser Website ist:
                  </p>
                  <p className="leading-relaxed mb-4" data-id="element-447" data-mp="3rfwlne4wzdc1">
                    CRM Kraft LLC
                    <br data-id="element-448" data-mp="3vh885ashrig0" />
                    Vertreten durch: Justus Kraft
                    <br data-id="element-449" data-mp="1jxivribtdh0x" />
                    7901 4th St. N, Ste. 300
                    <br data-id="element-450" data-mp="1fu4cmiskwkj9" />
                    St. Petersburg, FL 33702
                    <br data-id="element-451" data-mp="1av1952s8ymde" />
                    United States of America
                    <br data-id="element-452" data-mp="1axdp5aeg2mnt" />
                    Telefon:{' '}
                    <a href="tel:+491745444423" className="text-[#0ea5e9] hover:underline" data-id="element-453" data-mp="15x85ohibw6gt">
                      +49 174 5444423
                    </a>
                    <br data-id="element-454" data-mp="1yldr76h7hzhp" />
                    E-Mail:{' '}
                    <a href="mailto:justus@crm-kraft.de" className="text-[#0ea5e9] hover:underline" data-id="element-455" data-mp="1ttlvyin3v5l8">
                      justus@crm-kraft.de
                    </a>
                  </p>
                  <p className="leading-relaxed" data-id="element-456" data-mp="2mbr9i59zojz3">
                    Verantwortliche Stelle ist die natürliche oder juristische
                    Person, die allein oder gemeinsam mit anderen über die
                    Zwecke und Mittel der Verarbeitung von personenbezogenen
                    Daten (z. B. Namen, E-Mail-Adressen o. Ä.) entscheidet.
                  </p>

                  <h3 className="text-xl font-semibold text-white mb-3 mt-6" data-id="element-457" data-mp="1s4u074ro6nf9">
                    Speicherdauer
                  </h3>
                  <p className="leading-relaxed" data-id="element-458" data-mp="1x4gezin5cbq6">
                    Soweit innerhalb dieser Datenschutzerklärung keine
                    speziellere Speicherdauer genannt wurde, verbleiben Ihre
                    personenbezogenen Daten bei uns, bis der Zweck für die
                    Datenverarbeitung entfällt. Wenn Sie ein berechtigtes
                    Löschersuchen geltend machen oder eine Einwilligung zur
                    Datenverarbeitung widerrufen, werden Ihre Daten gelöscht,
                    sofern wir keine anderen rechtlich zulässigen Gründe für die
                    Speicherung Ihrer personenbezogenen Daten haben (z. B.
                    steuer- oder handelsrechtliche Aufbewahrungsfristen); im
                    letztgenannten Fall erfolgt die Löschung nach Fortfall
                    dieser Gründe.
                  </p>

                  <h3 className="text-xl font-semibold text-white mb-3 mt-6" data-id="element-459" data-mp="15uloujcu2yfl">
                    SSL- bzw. TLS-Verschlüsselung
                  </h3>
                  <p className="leading-relaxed" data-id="element-460" data-mp="e3nvdd2n79t2">
                    Diese Seite nutzt aus Sicherheitsgründen und zum Schutz der
                    Übertragung vertraulicher Inhalte, wie zum Beispiel
                    Bestellungen oder Anfragen, die Sie an uns als
                    Seitenbetreiber senden, eine SSL- bzw. TLS-Verschlüsselung.
                    Eine verschlüsselte Verbindung erkennen Sie daran, dass die
                    Adresszeile des Browsers von „http://" auf „https://"
                    wechselt und an dem Schloss-Symbol in Ihrer Browserzeile.
                    Wenn die SSL- bzw. TLS-Verschlüsselung aktiviert ist, können
                    die Daten, die Sie an uns übermitteln, nicht von Dritten
                    mitgelesen werden.
                  </p>
                </section>

                <section data-id="element-461" data-mp="10915p4wb1ipt">
                  <h2 className="text-2xl font-bold text-white mb-4" data-id="element-462" data-mp="108hpptq7t4ef">
                    4. Datenerfassung auf dieser Website
                  </h2>
                  <h3 className="text-xl font-semibold text-white mb-3" data-id="element-463" data-mp="8hbtvphj1suy">
                    Cookies
                  </h3>
                  <p className="leading-relaxed mb-4" data-id="element-464" data-mp="cjf5ce474xg8">
                    Unsere Internetseiten verwenden so genannte „Cookies".
                    Cookies sind kleine Textdateien und richten auf Ihrem
                    Endgerät keinen Schaden an. Sie werden entweder
                    vorübergehend für die Dauer einer Sitzung (Session-Cookies)
                    oder dauerhaft (permanente Cookies) auf Ihrem Endgerät
                    gespeichert. Session-Cookies werden nach Ende Ihres Besuchs
                    automatisch gelöscht. Permanente Cookies bleiben auf Ihrem
                    Endgerät gespeichert, bis Sie diese selbst löschen oder eine
                    automatische Löschung durch Ihren Webbrowser erfolgt.
                  </p>

                  <h3 className="text-xl font-semibold text-white mb-3 mt-6" data-id="element-465" data-mp="34e9ns1nixpe5">
                    Kontaktformular
                  </h3>
                  <p className="leading-relaxed mb-4" data-id="element-466" data-mp="2zfyati1xmyrp">
                    Wenn Sie uns per Kontaktformular Anfragen zukommen lassen,
                    werden Ihre Angaben aus dem Anfrageformular inklusive der
                    von Ihnen dort angegebenen Kontaktdaten zwecks Bearbeitung
                    der Anfrage und für den Fall von Anschlussfragen bei uns
                    gespeichert. Diese Daten geben wir nicht ohne Ihre
                    Einwilligung weiter.
                  </p>

                  <h3 className="text-xl font-semibold text-white mb-3 mt-6" data-id="element-467" data-mp="2bqn9nzgo72d1">
                    Anfrage per E-Mail, Telefon oder Telefax
                  </h3>
                  <p className="leading-relaxed" data-id="element-468" data-mp="8fgwk3scus3n">
                    Wenn Sie uns per E-Mail, Telefon oder Telefax kontaktieren,
                    wird Ihre Anfrage inklusive aller daraus hervorgehenden
                    personenbezogenen Daten (Name, Anfrage) zum Zwecke der
                    Bearbeitung Ihres Anliegens bei uns gespeichert und
                    verarbeitet. Diese Daten geben wir nicht ohne Ihre
                    Einwilligung weiter.
                  </p>
                </section>

                <section data-id="element-469" data-mp="36xuu1h9gvvc5">
                  <h2 className="text-2xl font-bold text-white mb-4" data-id="element-470" data-mp="36yns7tud1cio">
                    5. Plugins und Tools
                  </h2>
                  <h3 className="text-xl font-semibold text-white mb-3" data-id="element-471" data-mp="3bu35okogh6ek">
                    YouTube
                  </h3>
                  <p className="leading-relaxed mb-4" data-id="element-472" data-mp="32vhrf1q0odjl">
                    Diese Website bindet Videos der Website YouTube ein.
                    Betreiber der Website ist die Google Ireland Limited
                    („Google"), Gordon House, Barrow Street, Dublin 4, Irland.
                  </p>
                  <p className="leading-relaxed mb-4" data-id="element-473" data-mp="2sb5mqt8z4dv7">
                    Weitere Informationen zum Umgang mit Nutzerdaten finden Sie
                    in der Datenschutzerklärung von YouTube unter:{' '}
                    <a href="https://policies.google.com/privacy?hl=de" target="_blank" rel="noopener noreferrer" className="text-[#0ea5e9] hover:underline" data-id="element-474" data-mp="328aed8ll91je">
                      https://policies.google.com/privacy?hl=de
                    </a>
                    .
                  </p>

                  <h3 className="text-xl font-semibold text-white mb-3 mt-6" data-id="element-475" data-mp="3kyry4nog0msm">
                    Google Web Fonts
                  </h3>
                  <p className="leading-relaxed" data-id="element-476" data-mp="3g1t5yaocapx2">
                    Diese Seite nutzt zur einheitlichen Darstellung von
                    Schriftarten so genannte Web Fonts, die von Google
                    bereitgestellt werden. Beim Aufruf einer Seite lädt Ihr
                    Browser die benötigten Web Fonts in ihren Browsercache, um
                    Texte und Schriftarten korrekt anzuzeigen.
                  </p>
                </section>
              </div>
            </div>
          </div>
        </main>

        {/* Footer */}
        <footer className="bg-[#0a0a0a] border-t border-white/5 py-8" data-id="element-477" data-mp="34tno2aag2fl3">
          <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 text-center" data-id="element-478" data-mp="34raz3d69r4yj">
            <p className="text-gray-600 text-sm" data-id="element-479" data-mp="3jjl4g424u0zq">
              © {new Date().getFullYear()} Close CRM Agentur. Alle Rechte
              vorbehalten.
            </p>
          </div>
        </footer>
      </div>
    </>;
}